// CyberRoom.jsx
// ══════════════════════════════════════════════
// חדר סייבר - איחוד כל הקומפוננטות
// ══════════════════════════════════════════════

import { useEffect, useState } from "react";
import GlobalThreatMap       from "./GlobalThreatMap";
import NeuralNetwork         from "./NeuralNetwork";
import AttackSources         from "./AttackSources";
import ThreatLevelControl    from "./ThreatLevelControl";
import IPScanner             from "./IPScanner";
import BotRadar              from "./BotRadar";
import { useMamdani }        from "../../../context/MamdaniContext";
import "../../../styles/navbar/CyberRoom/CyberRoom.css";

const API_BASE = "https://api.anti-bot.ai";

export default function CyberRoom() {
  const [stats, setStats] = useState(null);
  const { mamdaniMode: mm, stats: mst } = useMamdani();

  useEffect(() => {
    if (mm) return; // במוד ממדאני לא צריך
    async function fetchStats() {
      try {
        const res  = await fetch(`${API_BASE}/api/cyber/live-stats`);
        const json = await res.json();
        if (json.success) setStats(json);
      } catch (err) {
        console.error("CyberRoom stats error:", err);
      }
    }
    fetchStats();
    const iv = setInterval(fetchStats, 30000);
    return () => clearInterval(iv);
  }, [mm]);

  // ── רמת איום ──
  const threatLevel = mm
    ? (mst.coordinated > 0 || mst.botsCount >= 5 ? "CRITICAL"
      : mst.botsCount >= 2 ? "HIGH" : "MEDIUM")
    : (stats?.threat_level ?? "HIGH");

  const threatColor = {
    CRITICAL: "#ff2244",
    HIGH:     "#ff8c00",
    MEDIUM:   "#ffd700",
    LOW:      "#00ff64",
  }[threatLevel] ?? "#ff8c00";

  return (
    <div className="cr-root">

      {/* ══ TOP HEADER ══ */}
      <div className="cr-topbar">
        <div className="cr-topbar-left">
          {mm ? (
            <>
              <div className="cr-topbar-stat">
                <span className="cr-stat-label">BOTS FOUND</span>
                <span className="cr-stat-value cyan">{mst.totalBots}</span>
              </div>
              <div className="cr-topbar-stat">
                <span className="cr-stat-label">ANTI-ISRAEL</span>
                <span className="cr-stat-value" style={{ color: "#ff6040" }}>{mst.antiIsrael}</span>
              </div>
            </>
          ) : (
            <>
              <div className="cr-topbar-stat">
                <span className="cr-stat-label">ACTIVE BOTS</span>
                <span className="cr-stat-value cyan">{stats?.active_bots?.toLocaleString() ?? "—"}</span>
              </div>
            </>
          )}
        </div>

        <div className="cr-topbar-center">
          <div>
            <div className="cr-logo-title">{mm ? "MAMDANI MONITOR" : "CYBER STATUS ROOM"}</div>
            <div className="cr-logo-sub">{mm ? "ANTI-ISRAEL BOT DETECTION" : "LINKS AI DEFENSE SYSTEM"}</div>
          </div>
          <span className="cr-shield">🛡</span>
        </div>

        <div className="cr-topbar-right">
          {mm ? (
            <>
              <div className="cr-topbar-stat">
                <span className="cr-stat-label">COORDINATED</span>
                <span className="cr-stat-value" style={{ color: "#a070ff" }}>{mst.coordinated}</span>
              </div>
              <div className="cr-topbar-stat">
                <span className="cr-stat-label">ACCOUNTS</span>
                <span className="cr-stat-value">{mst.accounts}</span>
              </div>
            </>
          ) : null}
          <div
            className="cr-threat-badge"
            style={{ borderColor: threatColor, color: threatColor, boxShadow: `0 0 12px ${threatColor}44` }}
          >
            <span className="cr-threat-dot" style={{ background: threatColor }} />
            THREAT: {threatLevel}
          </div>
        </div>
      </div>

      {/* ══ MAIN BODY ══ */}
      <div className="cr-body">

        {/* ── פאנל שמאל ── */}
        <div className="cr-left">
          <ThreatLevelControl />
          <NeuralNetwork />
          <BotRadar />
        </div>

        {/* ── מפה מרכזית ── */}
        <div className="cr-center">
          <GlobalThreatMap />
        </div>

        {/* ── פאנל ימין ── */}
        <div className="cr-right">
          <IPScanner />
          <AttackSources />
        </div>

      </div>

    </div>
  );
}